import React, { useState, useRef } from "react";
import classNames from "classnames";
import { useElementSize } from "utils/helpers";
import { useTranslation } from 'react-i18next';
import "./SortHeader.scss";

import ButtonDropdown from "components/uiComponents/ButtonDropdown";

import { ReactComponent as ArrowSortIcon } from "static/icons/arrow-sort.svg";
import { ReactComponent as ArrowIcon } from "static/icons/arrow.svg";

const DropdownItem = ({
  item,
  onClick,
}) => {
  return (
    <div
      className={classNames({
        "dropdown-item": true,
      })}
      onClick={onClick}
    >
      {item.value}
    </div>
  );
};

const SortButton = ({
  label,
  openStatus,
  onClick,
}) => {
  return (
    <div
      className="sort-button"
      onClick={onClick}
    >
      <p className="sort-button__text">
        {label}
      </p>

      <div
        className={classNames({
          "sort-button__icon": true,
          "sort-button__icon--active": openStatus,
        })}
      >
        <ArrowIcon />
      </div>

      <div
        className="sort-button__line"
      />
    </div>
  );
};

const SortHeader = ({
  data,
  viewType,
  onChooseSortType,
  onDirectionButtonClick,
  onSortItemClick,
  onWidthChange,
}) => {
  const { t } = useTranslation();
  
  const titleRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const [width, height] = useElementSize(titleRef?.current);

  onWidthChange(width);

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleSortButtonClick = () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    } else {
      setIsDropdownOpen(true);
    }
  };

  return (
    <div className="sort-header">
      {viewType === 'list' &&
        <>
          <div className="sort-header__empty"/>
          {data.map(item => {
            const handleItemClick = () => {
              onSortItemClick(item);
            };

            return (
              <div 
                key={item.key}
                className={`sort-header__${item.key}`}
                ref={item.key === 'name' ? titleRef : null}
              >
                <div
                  className='sort-header__sort'
                  onClick={handleItemClick}
                >
                  <span
                    className={classNames({
                      'sort-header__text': true,
                      'sort-header__text--active': item.isActive,
                    })}
                  >
                    {item.value}
                  </span>

                  <ArrowSortIcon
                    className={classNames({
                      'sort-header__sort-icon': true,
                      'sort-header__sort-icon--active': item.isActive,
                      'sort-header__sort-icon--asc': !item.isDescending,
                    })}
                  />
                </div>
              </div>
            );
          })}
        </>
      }

      {viewType === 'block' &&
        <>
          <p className="sort-header__sortBy">
            {t('sort_by')}:
          </p>

          <ButtonDropdown
            buttonElement={
              <SortButton
                label={data.find(item => item.isActive).value}
                openStatus={isDropdownOpen}
                onClick={handleSortButtonClick}
              />
            }
            buttonBorder
            dropdownPosition="left"
            onCloseDropdown={handleCloseDropdown}
            isFullHeight
            dropDownCloseStatus={isDropdownOpen}
          >
            {data.map(item => {
              const handleClickDropdownItem = () => {
                setIsDropdownOpen(false);
                onChooseSortType(item);
              };

              return (
                <DropdownItem
                  key={item.key}
                  item={item}
                  onClick={handleClickDropdownItem}
                />
              );
            })}
          </ButtonDropdown>

          <div
            className={classNames({
              "sort-button__sort-icon": true,
              "sort-button__sort-icon--asc": !data.find(item => item.isActive).isDescending,
            })}
            onClick={onDirectionButtonClick}
          >
            <ArrowSortIcon />
          </div>
        </>
      }
    </div>
  );
};

export default SortHeader;
